module.exports = __webpack_public_path__ + "img/pay.b8837613.png";